import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from '../components/Hero';
import AfgiftsfriBanner from '../components/AfgiftsfriBanner';
import ShowcaseGallery from '../components/ShowcaseGallery';
import StepForm from '../components/StepForm';
import HowItWorks from '../components/HowItWorks';
import Benefits from '../components/Benefits';
import Reviews from '../components/Reviews';

export default function HomePage() {
  const location = useLocation();

  useEffect(() => {
    if (location.state && location.state.scrollTo) {
      const id = location.state.scrollTo;
      // Clear the state so it doesn't scroll again on refresh
      window.history.replaceState({}, document.title);
      
      // Small timeout to ensure elements are rendered
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          const isLargeScreen = window.innerWidth >= 1024;
          const offset = isLargeScreen ? 140 : 80; // height of sticky header
          const bodyRect = document.body.getBoundingClientRect().top;
          const elementRect = element.getBoundingClientRect().top;
          const elementPosition = elementRect - bodyRect;
          const offsetPosition = elementPosition - offset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  }, [location]);

  return (
    <>
      <Hero />
      <AfgiftsfriBanner />
      <ShowcaseGallery />
      <StepForm />
      <HowItWorks />
      <Benefits />
      <Reviews />
    </>
  );
}
